
import { useTranslation } from 'react-i18next';

export default function KnowledgeHub() {
  const { t } = useTranslation();

  const publications = [
    {
      title: 'Mülteci Hakları ve Uluslararası Koruma',
      category: 'Hukuk',
      date: '15 Ocak 2024',
      author: 'Dr. Ayşe Yılmaz',
      excerpt: 'Savaş ve zulümden kaçan bireylerin uluslararası hukuk çerçevesinde sahip oldukları haklar ve Hollanda\'daki iltica süreçleri hakkında kapsamlı rehber.',
      image: 'https://public.readdy.ai/ai/img_res/7cb55d30584ba23b412c9a2b2a8578b3.jpg',
    },
    {
      title: 'Travma Sonrası Destek ve Psikososyal Bakım',
      category: 'Sağlık',
      date: '10 Ocak 2024',
      author: 'Prof. Mehmet Demir',
      excerpt: 'Savaş ve zorunlu göç travması yaşayan bireylerin iyileşme süreçlerinde psikososyal destek hizmetlerinin önemi ve Hollanda\'daki erişim yolları.',
      image: 'https://readdy.ai/api/search-image?query=Peaceful%20healing%20scene%20showing%20gentle%20caring%20hands%20holding%20growing%20plant%20with%20soft%20pastel%20colors%20of%20warm%20peach%2C%20gentle%20mint%20green%20and%20soft%20sky%20blue.%20Minimalist%20artistic%20composition%20emphasizing%20growth%2C%20healing%2C%20mental%20wellness%20and%20compassionate%20support.%20Clean%20simple%20background%20with%20symbolic%20elements%20representing%20recovery%2C%20hope%2C%20positive%20transformation%20and%20emotional%20wellbeing%20in%20safe%20supportive%20environment&width=800&height=500&seq=knowledge-healing-wellness-growth-009&orientation=landscape',
    },
    {
      title: 'Entegrasyon Sürecinde Dil ve Kültürel Uyum',
      category: 'Eğitim',
      date: '5 Ocak 2024',
      author: 'Eng. Fatma Öztürk',
      excerpt: 'Zorlu göç deneyimi sonrası yeni bir topluma uyum sağlama sürecinde dil öğreniminin rolü ve kültürlerarası köprü kurmanın önemi.',
      image: 'https://readdy.ai/api/search-image?query=Bright%20cheerful%20scene%20showing%20open%20books%2C%20colorful%20speech%20bubbles%20and%20bridge%20connecting%20people%20in%20soft%20pastel%20colors%20of%20warm%20coral%2C%20gentle%20sky%20blue%20and%20soft%20yellow.%20Minimalist%20artistic%20composition%20emphasizing%20learning%2C%20communication%2C%20cultural%20connection%20and%20positive%20integration.%20Clean%20simple%20background%20with%20symbolic%20elements%20representing%20education%2C%20language%20success%2C%20friendship%20and%20building%20new%20community%20connections&width=800&height=500&seq=knowledge-language-learning-connection-010&orientation=landscape',
    },
  ];

  return (
    <section id="knowledge" className="py-24 bg-gradient-to-br from-[#F8F9FA] to-[#E9ECEF]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-4">
            {t('knowledge.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('knowledge.subtitle')}
          </p>
        </div>

        <div className="mb-8">
          <h3 className="text-2xl font-bold text-[#1A2332] mb-6">{t('knowledge.featured')}</h3>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {publications.map((pub, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden"
            >
              <div className="w-full h-48">
                <img
                  src={pub.image}
                  alt={pub.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="px-3 py-1 bg-[#C9A961]/10 text-[#C9A961] rounded-full text-xs font-semibold">
                    {pub.category}
                  </span>
                  <span className="text-xs text-gray-500">{pub.date}</span>
                </div>
                <h3 className="text-xl font-bold text-[#1A2332] mb-3 leading-tight">
                  {pub.title}
                </h3>
                <p className="text-gray-600 text-sm mb-4 leading-relaxed">{pub.excerpt}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-gray-500">{pub.author}</span>
                  <button className="text-[#C9A961] hover:text-[#B89851] font-semibold text-sm flex items-center gap-1 whitespace-nowrap cursor-pointer">
                    {t('knowledge.readMore')}
                    <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="px-8 py-3 bg-[#1A2332] text-white rounded-lg hover:bg-[#2A3342] transition-colors font-semibold whitespace-nowrap cursor-pointer">
            {t('knowledge.viewAll')}
          </button>
        </div>
      </div>
    </section>
  );
}
